// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mE_G","comment":"styles_comment__1qJh2"};